

















































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'
import {ResponsavelCollection} from '@/model/collection/ResponsavelCollection'
import {ListResponsavelSchema} from '@/schema/resource/Responsavel/ListResponsavelSchema'
import {CsvResponsavelSchema} from '@/schema/resource/Responsavel/CsvResponsavelSchema'
import PopoverResponsavel from '@/components/PopoverResponsavel.vue'

@Component({
  components: {PopoverResponsavel},
})
export default class ListResponsavelView extends Mixins(MixinQueryRouter) {
  schema = new ListResponsavelSchema()
  collection = new ResponsavelCollection()

  async created() {
    this.collection.perPage = 20
    await this.query()
  }

  async showResponsavelPopover(resp: Responsavel, index: number) {
    await this.$nextTick()
    this.$tip.show(`responsavel${index}`, resp)
  }

  async downloadXlsx() {
    const {ascending, orderBy, page, limit, ...params} = this.collection.params

    const collection = new ResponsavelCollection()
      .clearFilters()
      .addFilter(params)

    await collection.listCsvResponsavel()
    this.$xlsx.downloadFromSchema(
      collection.all(),
      new CsvResponsavelSchema(),
      $.t('schema.CsvResponsavel.title') as string
    )
  }

  getInactiveClass(index: number) {
    return this.collection.get(index).ativo ? '' : 'inactive'
  }
}
